import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import BalanceOperations from './balance-operations/balance-operations'
import MemberBindingRecord from './member-binding-record/member-binding-record'
import MemberBlacklist from './member-blacklist/member-blacklist'
import MemberBirthday from './member-birthday/member-birthday'
import MemberCardRecord from './member-card-record/member-card-record'
import MemberDetail from './member-detail/member-detail'
import MemberGroup from './member-group/member-group'
import MemberImport from './member-import/member-import'
import MemberLevel from './member-level/member-level'
import MemberLevelChangeRecord from './member-level-change-record/member-level-change-record'
import MemberList from './member-list/member-list'
import MemberCardSetting from './member-setting/member-card-setting'
import ChainCoinSetting from './member-setting/chain-coin-setting'
import MemberBenefit from './member-setting/member-benefit'
import MemberDiscount from './member-setting/member-discount'
import MemberPrice from './member-setting/member-price'
import MemberSetting from './member-setting/member-setting'
import PointsSetting from './member-setting/points-setting'
import RechargeSetting from './member-setting/recharge-setting'
import GrowthRuleSetting from './member-setting/growth-rule-setting'
import SvipSetting from './member-setting/svip-setting'
import PointsOperations from './points-operations/points-operations'
import PointsCouponMall from './points-coupon-mall/points-coupon-mall'
import RechargeRecord from './recharge-record/recharge-record'
import SvipPurchaseRecord from './svip-purchase-record/svip-purchase-record'

const path = '/main/member'

export const MEMBER_LIST = path + '/list'
export const MEMBER_RECHARGE_RECORD = path + '/rechargeRecord'
export const MEMBER_SETTING = path + '/setting'
export const MEMBER_SETTING_BASIC = path + '/setting/basic'
export const MEMBER_SETTING_ASSETS = path + '/setting/assets'
export const MEMBER_SETTING_MARKETING = path + '/setting/marketing'
export const MEMBER_SETTING_CHAIN = path + '/setting/chain'
export const MEMBER_CARD_SETTING = path + '/setting/card'
export const MEMBER_POINTS_SETTING = path + '/setting/points'
export const MEMBER_POINTS_OPERATIONS = path + '/setting/pointsOperations'
export const MEMBER_POINTS_COUPON_MALL = path + '/setting/pointsCouponMall'
export const MEMBER_RECHARGE_SETTING = path + '/setting/recharge'
export const MEMBER_BALANCE_OPERATIONS = path + '/setting/balanceOperations'
export const MEMBER_BENEFIT_SETTING = path + '/setting/benefit'
export const MEMBER_DISCOUNT_SETTING = path + '/setting/discount'
export const MEMBER_PRICE_SETTING = path + '/setting/price'
export const MEMBER_SVIP_SETTING = path + '/setting/svip'
export const MEMBER_SVIP_PURCHASE_RECORD = path + '/setting/svipPurchaseRecord'
export const MEMBER_GROWTH_RULE_SETTING = path + '/setting/growthRule'
export const MEMBER_BLACKLIST = path + '/setting/blacklist'
export const MEMBER_CHAIN_COIN_SETTING = path + '/setting/chainCoin'
export const MEMBER_DETAIL = path + '/detail'
export const MEMBER_IMPORT = path + '/import'
export const MEMBER_GROUP = path + '/group'
export const MEMBER_LEVEL = path + '/level'
export const MEMBER_LEVEL_CHANGE_RECORD = path + '/levelChangeRecord'
export const MEMBER_BIRTHDAY = path + '/birthday'
export const MEMBER_BINDING_RECORD = path + '/bindingRecord'
export const MEMBER_CARD_RECORD = path + '/cardRecord'

export default (props: RouteComponentProps) => (
    <Switch>
        <Route path={props.match.path + '/list'} component={MemberList} />
        <Route path={props.match.path + '/detail'} component={MemberDetail} />
        <Route path={props.match.path + '/rechargeRecord'} component={RechargeRecord} />
        <Route exact path={MEMBER_SETTING_BASIC} component={MemberSetting} />
        <Route exact path={MEMBER_SETTING_ASSETS} component={MemberSetting} />
        <Route exact path={MEMBER_SETTING_MARKETING} component={MemberSetting} />
        <Route exact path={MEMBER_SETTING_CHAIN} component={MemberSetting} />
        <Route path={props.match.path + '/setting/card'} component={MemberCardSetting} />
        <Route path={props.match.path + '/setting/pointsOperations'} component={PointsOperations} />
        <Route path={props.match.path + '/setting/pointsCouponMall'} component={PointsCouponMall} />
        <Route path={props.match.path + '/setting/points'} component={PointsSetting} />
        <Route path={props.match.path + '/setting/balanceOperations'} component={BalanceOperations} />
        <Route path={props.match.path + '/setting/recharge'} component={RechargeSetting} />
        <Route path={props.match.path + '/setting/benefit'} component={MemberBenefit} />
        <Route path={props.match.path + '/setting/discount'} component={MemberDiscount} />
        <Route path={props.match.path + '/setting/price'} component={MemberPrice} />
        <Route path={props.match.path + '/setting/svipPurchaseRecord'} component={SvipPurchaseRecord} />
        <Route path={props.match.path + '/setting/svip'} component={SvipSetting} />
        <Route path={props.match.path + '/setting/growthRule'} component={GrowthRuleSetting} />
        <Route path={props.match.path + '/setting/blacklist'} component={MemberBlacklist} />
        <Route path={props.match.path + '/setting/chainCoin'} component={ChainCoinSetting} />
        <Redirect exact from={MEMBER_SETTING} to={MEMBER_SETTING_BASIC} />
        <Route path={props.match.path + '/group'} component={MemberGroup} />
        <Route path={props.match.path + '/birthday'} component={MemberBirthday} />
        <Route path={props.match.path + '/bindingRecord'} component={MemberBindingRecord} />
        <Route path={props.match.path + '/cardRecord'} component={MemberCardRecord} />
        <Route path={props.match.path + '/levelChangeRecord'} component={MemberLevelChangeRecord} />
        <Route path={props.match.path + '/level'} component={MemberLevel} />
        <Route path={props.match.path + '/import'} component={MemberImport} />
        <Redirect to={MEMBER_LIST} />
    </Switch>
)
